import React from 'react';

interface IconProps {
  className?: string;
  size?: number;
}

export const WashboardIcon: React.FC<IconProps> = ({ className, size = 24 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.5"
    strokeLinecap="round"
    strokeLinejoin="round"
    className={className}
  >
    {/* Washboard - corrugated surface */}
    <path d="M3 18h18" />
    <path d="M4 14v4" />
    <path d="M6 15v3" />
    <path d="M8 14v4" />
    <path d="M10 15v3" />
    <path d="M12 14v4" />
    <path d="M14 15v3" />
    <path d="M16 14v4" />
    <path d="M18 15v3" />
    <path d="M20 14v4" />
    <path d="M3 12c1.5 1 3 1 4.5 0s3-1 4.5 0 3 1 4.5 0 3-1 4.5 0" />
  </svg>
);
